import { Controller } from "@hotwired/stimulus"

// A Stimulus controller for the Dropbox folder browser
export default class extends Controller {
  static targets = ["folderList", "folderPath"]
  
  connect() {
    console.log("Dropbox Folders controller connected")
    
    // Add event listener to browse button (outside this controller)
    const browseBtn = document.getElementById('browse-folder-btn')
    if (browseBtn) {
      browseBtn.addEventListener('click', () => this.loadFolders())
    }
  }
  
  loadFolders(path = "") {
    // Show loading state
    if (this.hasFolderListTarget) {
      this.folderListTarget.innerHTML = '<div class="text-center my-3"><div class="spinner-border spinner-border-sm" role="status"></div> Loading folders...</div>'
    }
    
    // Fetch folders from the server using the routes path provided by data-list-folders-url attribute
    const listFoldersUrl = this.element.dataset.listFoldersUrl || "/dashboard/automation/list_dropbox_folders"
    fetch(`${listFoldersUrl}?path=${encodeURIComponent(path)}`)
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          this.showError(data.error)
          return
        }
        
        this.renderFolders(data.folders, path)
      })
      .catch(error => {
        this.showError(`Failed to load folders: ${error.message}`)
      })
  }
  
  renderFolders(folders, currentPath) {
    if (!this.hasFolderListTarget) return
    
    if (folders.length === 0) {
      this.folderListTarget.innerHTML = '<p class="text-muted">No folders found</p>'
      return
    }
    
    // Create a breadcrumb for navigation
    let breadcrumb = '<nav aria-label="breadcrumb" class="mb-3"><ol class="breadcrumb mb-0">'
    
    // Add root folder
    breadcrumb += `<li class="breadcrumb-item"><a href="#" data-action="click->dropbox-folders#navigateTo" data-path="">Root</a></li>`
    
    // Add path parts
    if (currentPath) {
      const parts = currentPath.split('/').filter(p => p.length > 0)
      let pathSoFar = ''
      
      parts.forEach((part, index) => {
        pathSoFar += `/${part}`
        
        if (index === parts.length - 1) {
          breadcrumb += `<li class="breadcrumb-item active">${part}</li>`
        } else {
          breadcrumb += `<li class="breadcrumb-item"><a href="#" data-action="click->dropbox-folders#navigateTo" data-path="${pathSoFar}">${part}</a></li>`
        }
      })
    }
    
    breadcrumb += '</ol></nav>'
    
    // Create folder list
    let folderList = `
      ${breadcrumb}
      <div class="list-group">
    `
    
    folders.forEach(folder => {
      folderList += `
        <button type="button" class="list-group-item list-group-item-action d-flex align-items-center" 
                data-action="click->dropbox-folders#selectFolder" 
                data-path="${folder.path}">
          <i class="fa-solid fa-folder me-2 text-warning"></i>
          <span>${folder.name}</span>
          <i class="fa-solid fa-chevron-right ms-auto"></i>
        </button>
      `
    })
    
    folderList += '</div>'
    
    this.folderListTarget.innerHTML = folderList
  }
  
  selectFolder(event) {
    const path = event.currentTarget.dataset.path
    
    // Navigate to the folder
    this.loadFolders(path)
    
    // Set the folder path in the input field
    if (this.hasFolderPathTarget) {
      this.folderPathTarget.value = path
    } else {
      // Find the input with name="settings[folder_path]"
      const input = document.querySelector('input[name="settings[folder_path]"]')
      if (input) {
        input.value = path
      }
    }
  }
  
  navigateTo(event) {
    event.preventDefault()
    const path = event.currentTarget.dataset.path
    this.loadFolders(path)
  }
  
  showError(message) {
    if (this.hasFolderListTarget) {
      this.folderListTarget.innerHTML = `
        <div class="alert alert-danger">
          <i class="fa-solid fa-exclamation-circle me-2"></i>
          ${message}
        </div>
      `
    }
  }
}